<ng-container *transloco="let t;">
<div class="col-12 col-lg-8 col-md-8 p-2 bulkUpload-rightColumn-border">
    <div class="mapping-info-desc">
        <i data-feather="alert-circle" class="" size="16"></i>
        <h2 class="bulk-info-section-title">{{t('Step title (match column steps) - Drag fields from the right side picker to the left side boxes matching your data. Unmapped columns will not be imported in SimpleSign')}}.</h2>
    </div>

    <h3 class="title-heading-text">{{t('Columns section title (match column steps) - Spreadsheet columns')}}</h3>

    <div class="custom-control custom-checkbox">
        <input type="checkbox" [ngModel]="first_line_titles" (ngModelChange)="onFirst_line_titlesChange($event)" class="custom-control-input" id="customCheck2"/>
        <label class="custom-control-label" for="customCheck2">{{t('First row contains title label (match column steps) - The first row in my file is a column header, do not import it')}}.</label>
    </div>

    <div class="row ms-0 me-0 mt-2 columns-mapping-container">
        <div class="col-12 ps-0 pe-25 pe-2 mapped-fields-container">
            <div class="data-fields-container"
            cdkDropList
            #tableList="cdkDropList"
            [cdkDropListData]="defaultFields"
            (cdkDropListDropped)="drop($event)"
            
            >
                @for (item of rowItems; track item; let i = $index) {
                    <div class="row">
                        <div class="col-6">
                            <div class="data-field-list">
                                <div class="data-field-column-lt">
                                    <div class="data-field-name data-field-name-ciolumn">
                                        <span *ngIf="first_line_titles && cardColumns">{{ item.title }}</span>
                                        <label class="data-field-value">{{ item.value }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="pe-0 ps-25 h-100">
                                <div class="data-fields-container-area h-100">
                                    <div class="data-fields-container example-list" cdkDropListGroup cdkDrag [attr.index]="i">
                                        <div class="data-field-list" *ngIf="defaultFields[i] && defaultFields[i].is_empty === 0">
                                            <div class="data-field-column-lt">
                                                <div class="data-field-icon">
                                                    @if (defaultFields[i]?.icon) {
                                                        <span [data-feather]="defaultFields[i]?.icon ||'users'" [size]="16"></span>
                                                    } @else if (defaultFields[i]?.bootstrapIcon) {
                                                        <i [ngClass]="defaultFields[i]?.bootstrapIcon ||'users'"></i>
                                                    } @else {
                                                        <i [data-feather]="'users'" [size]="16"></i>
                                                    }
                                                </div>
                                                <div class="data-field-name">
                                                    <span>{{ defaultFields[i].label }}</span>
                                                </div>
                                            </div>
                                            <div class="data-field-actionBtn">
                                        <span class="delete-icon" (click)="removeField(i)">
                                            <i [data-feather]="'x'" [size]="14"></i>
                                        </span>
                                            </div>
                                        </div>

                                        <div class="data-field-list data-field-empty h-100" *ngIf="defaultFields && defaultFields[i]?.is_empty === 1">
                                            <div class="data-field-column-lt">
                                                <div class="data-field-name">
                                                    <span>{{t('Drag and drop area (match column steps) - Drag and Drop field here')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                } @empty {
                    <div class="data-field-list">
                        <div class="data-field-column-lt w-100">
                            @if (loading){
                                <app-skeleton class="w-100" [loop]="3" [section]="'user-stats-item'"></app-skeleton>
                            } @else {
                                {{ t('No mappings notification (match column steps) - There is no mapping to show. Please go back to first step and upload a CSV/XLXS file') }}
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

<div class="col-12 col-lg-4 col-md-4 pt-2 pb-2 ps-0 pe-0">
    <div class="input-group input-group-merge search-input-bulk mb-2 ps-2 pe-2">
        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i data-feather="search"></i>
                        </span>
        </div>
        <input
                type="text"
                class="form-control"
                [placeholder]="t('Search field placeholder (match column steps) - Search for a field')"
                aria-label="Search for a field"
                [ngModel]="searchString"
                (ngModelChange)="onSearchStringChange($event)"
        />
    </div>

    <div class="document-tabs-class">
        <ul ngbNav #navWithIcons="ngbNav" class="nav-tabs nav-justified border-bottom mb-0"
            [(activeId)]="activeTabIndex">
            @for (category of cardsGroupedBy$ | async | keyvalue; track category; let index = $index) {
                <li [ngbNavItem]="index">
                    <a ngbNavLink placement="top" [autoClose]="true" triggers="hover" [ngbTooltip]="category.key || ''">
                      <span class="d-inline-flex">
                        @if (category.value[0]?.icon) {
                            <span [data-feather]="category.value[0]?.icon ||'users'" [size]="18"></span>
                        } @else if (category.value[0]?.bootstrapIcon) {
                            <i [ngClass]="category.value[0]?.bootstrapIcon ||'users'"></i>
                        }
                          @if(category.value | isMappingFieldRequired){
                              <span  class="text-danger">*</span>
                          }  
                          
                      </span>
                        
                  
                    </a>
                    <ng-template ngbNavContent>
                        <div class="data-fields-container example-list"
                             cdkDropList
                             #menuList="cdkDropList"
                             [cdkDropListData]="cardColumns"
                             cdkDropListSortingDisabled
                             (cdkDropListDropped)="drop($event)"
                        >
                            @for (cardColumnItem of category.value; track cardColumnItem) {
                                <div class="data-field-list" cdkDrag
                                     [cdkDragData]="cardColumnItem">
                                    <div class="data-field-column-lt">
                                        <div class="data-field-icon">
                                            @if (category.value[0]?.icon) {
                                                <i [data-feather]="category.value[0]?.icon ||'users'" [size]="16"></i>
                                            } @else if (category.value[0]?.bootstrapIcon) {
                                                <i [ngClass]="category.value[0]?.bootstrapIcon ||'users'"></i>
                                            }
                                        </div>
                                        <div class="data-field-name">
                                            <span>{{ cardColumnItem.label }} </span>
                                            @if (cardColumnItem | isMappingFieldRequired){
                                                <span class="text-danger">*</span>
                                            }
                                        </div>
                                    </div>
                                    <div class="data-field-contact">
                                        <span>{{ cardColumnItem.dataFieldContact }}</span>
                                    </div>
                                </div>
                            }
                            @empty {
                                <div  class="pb-2 mb-1 pt-2 w-100 text-center">
                                    @if (loading){
                                        <app-skeleton class="w-100" [loop]="3" [section]="'match-columns-loader'"></app-skeleton>
                                    }@else{
                                        {{t("All cards mapped notification (bulk upload match column steps) - All cards has been mapped")}}
                                    }
                                </div>
                            }
                        </div>
                    </ng-template>
                </li>
            }  @empty {
                <div  class="pb-2 mb-1 pt-2 w-100 text-center">
                    @if (loading){
                        <app-skeleton class="w-100" [loop]="3" [section]="'match-columns-loader'"></app-skeleton>
                    }@else{
                        {{t("All cards mapped notification (bulk upload match column steps) - All cards has been mapped")}}
                    }
                </div>
            }

        </ul>
        <div [ngbNavOutlet]="navWithIcons" class="p-2"></div>

    </div>
    @if(hasRequiredFields$ | async){
        <div class="p-2 tab-content">
            {{ t('Required field symbol caption (match column steps) -  Fields marked with  are mandatory', {mark: '*'}) }}
        </div>  
    }
</div>
</ng-container>